/**
 * @author: subhasish.ghosh@zoom.us
 */

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Slide } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { SnackbarProvider, useSnackbar } from "notistack";
import React, { Suspense, useEffect } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./App.css";
import GoToTop from "@components/GotoTop";
import { useQueryClient } from "@tanstack/react-query";
import { goToTop, isCurrentRoleAdmin, isProdEnvironment } from "@utils/utils";
import { useProfile } from "@hooks/useProfile";
import AuthenticationWrapper from "@wrapper/AuthenticationWrapper";
import PageWrapper from "@wrapper/PageWrapper";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

function App() {
  const queryClient = useQueryClient();

  const { data: userActionData, isLoading: userInfoLoading } = useProfile();

  useEffect(() => {
    goToTop();
  }, []);

  useEffect(() => {
    return () => queryClient.clear();
  }, [queryClient]);

  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="container">
          <SnackbarProvider
            className="operations-snackbar"
            maxSnack={1}
            TransitionComponent={Transition}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            action={(snackbarKey) => (
              <SnackbarCloseButton snackbarKey={snackbarKey} />
            )}
            autoHideDuration={10000}
          >
            <AuthenticationWrapper userInfoLoading={userInfoLoading}>
              <Router>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <PageWrapper
                        userActionData={userActionData}
                        userInfoLoading={userInfoLoading}
                      />
                    }
                  />
                </Routes>
              </Router>
            </AuthenticationWrapper>
          </SnackbarProvider>
        </div>
        <GoToTop />
      </LocalizationProvider>
    </div>
  );
}

const Transition = (props) => <Slide {...props} direction="left" />;

const SnackbarCloseButton = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon style={{ color: "white" }} />
    </IconButton>
  );
};

export default App;
